(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xh-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xh-main-product-v1"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalize = (value) => String(value ?? '').trim().toLocaleLowerCase('de-DE');

    const renderRaisedCurrencyPrice = (element, formattedPrice) => {
      if (!element) return;

      const value = String(formattedPrice ?? '').trim();
      const match = value.match(/^(.*?)(?:\s+)(\S+)$/u);

      if (!match) {
        element.textContent = value;
        return;
      }

      const amount = document.createElement('span');
      amount.className = 'xh-product-price__amount';
      amount.textContent = match[1];

      const currency = document.createElement('span');
      currency.className = 'xh-product-price__currency';
      currency.textContent = match[2];

      element.replaceChildren(amount, currency);
    };

    document.querySelectorAll('[data-xh-product-page]').forEach((root) => {
      if (root.dataset.xhInitialized === 'true') return;
      root.dataset.xhInitialized = 'true';

      const dataElement = root.querySelector('[data-xh-variant-data]');
      const variants = dataElement ? JSON.parse(dataElement.textContent) : [];
      const optionButtons = [...root.querySelectorAll('[data-xh-option]')];

      const variantInput = root.querySelector('[data-xh-variant-id]');
      const priceElement = root.querySelector('[data-xh-price]');
      const mobilePrice = root.querySelector('[data-xh-mobile-price]');
      const compareElement = root.querySelector('[data-xh-compare]');
      const saleElement = root.querySelector('[data-xh-sale]');
      const availability = root.querySelector('[data-xh-availability]');
      const availabilityText = root.querySelector('[data-xh-availability-text]');
      const addButton = root.querySelector('[data-xh-add-to-cart]');
      const addLabel = root.querySelector('[data-xh-add-label]');
      const mobileAdd = root.querySelector('[data-xh-mobile-add]');
      const mobileAddLabel = root.querySelector('[data-xh-mobile-add-label]');
      const quantityInput = root.querySelector('[data-xh-quantity-input]');
      const mobileSticky = root.querySelector('[data-xh-mobile-sticky]');
      const productForm = root.querySelector('.xh-product-form');
      const buyNowButton = root.querySelector('[data-xh-buy-now]');
      const buyNowLabel = root.querySelector('[data-xh-buy-now-label]');
      const formError = root.querySelector('.xh-product-form__error');

      const slides = [...root.querySelectorAll('[data-xh-slide]')];
      const thumbs = [...root.querySelectorAll('[data-xh-thumb]')];

      const initialVariantId = Number(variantInput?.value);
      const initialVariant =
        variants.find((variant) => Number(variant.id) === initialVariantId) ||
        variants[0];

      let selectedOptions = initialVariant ? [...initialVariant.options] : [];

      const showMedia = (mediaId) => {
        if (!mediaId || slides.length === 0) return;

        slides.forEach((slide) => {
          const isActive = String(slide.dataset.mediaId) === String(mediaId);
          slide.hidden = !isActive;
          slide.classList.toggle('is-active', isActive);
        });

        thumbs.forEach((thumb) => {
          const isActive = String(thumb.dataset.mediaId) === String(mediaId);
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

      };

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => showMedia(thumb.dataset.mediaId));
      });

      const findSelectedVariant = () =>
        variants.find((variant) =>
          variant.options.every(
            (option, index) => normalize(option) === normalize(selectedOptions[index])
          )
        );

      const updateOptionAvailability = () => {
        optionButtons.forEach((button) => {
          const optionIndex = Number(button.dataset.optionIndex);
          const candidateOptions = [...selectedOptions];
          candidateOptions[optionIndex] = button.dataset.optionValue;

          const matchingVariants = variants.filter((variant) =>
            variant.options.every(
              (option, index) => normalize(option) === normalize(candidateOptions[index])
            )
          );

          const exists = matchingVariants.length > 0;
          const isAvailable = matchingVariants.some((variant) => variant.available);

          button.disabled = !exists;
          button.classList.toggle('is-unavailable', exists && !isAvailable);
        });
      };

      const updateVariant = (variant) => {
        if (!variant) return;

        selectedOptions = [...variant.options];

        if (variantInput) variantInput.value = variant.id;

        optionButtons.forEach((button) => {
          const optionIndex = Number(button.dataset.optionIndex);
          const selected =
            normalize(button.dataset.optionValue) === normalize(variant.options[optionIndex]);

          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });

        renderRaisedCurrencyPrice(priceElement, variant.price_formatted);
        renderRaisedCurrencyPrice(mobilePrice, variant.price_formatted);

        const onSale =
          Number(variant.compare_at_price) > 0 &&
          Number(variant.compare_at_price) > Number(variant.price);

        if (compareElement) {
          compareElement.hidden = !onSale;
          compareElement.textContent = onSale ? variant.compare_at_price_formatted : '';
        }

        if (saleElement) saleElement.hidden = !onSale;

        const isAvailable = Boolean(variant.available);

        if (addButton) addButton.disabled = !isAvailable;
        if (mobileAdd) mobileAdd.disabled = !isAvailable;
        if (buyNowButton) buyNowButton.disabled = !isAvailable;
        if (addLabel) addLabel.textContent = isAvailable ? 'In den Warenkorb' : 'Ausverkauft';
        if (mobileAddLabel) mobileAddLabel.textContent = isAvailable ? 'In den Warenkorb' : 'Ausverkauft';
        if (buyNowLabel) buyNowLabel.textContent = isAvailable ? 'Zum Checkout' : 'Ausverkauft';

        const isLowStock =
          isAvailable &&
          Boolean(variant.inventory_management) &&
          Number(variant.inventory_quantity) > 0 &&
          Number(variant.inventory_quantity) <= 5;

        availability?.classList.toggle('is-low-stock', isLowStock);
        availability?.classList.toggle('is-sold-out', !isAvailable);

        if (availabilityText) {
          if (!isAvailable) {
            availabilityText.textContent = 'Ausverkauft';
          } else if (isLowStock) {
            availabilityText.textContent = 'Nur noch wenige verfügbar';
          } else {
            availabilityText.textContent = 'Auf Lager';
          }
        }

        const availabilityLabel = !isAvailable
          ? 'Ausverkauft'
          : isLowStock
            ? 'Nur noch wenige verfügbar'
            : 'Auf Lager';


        if (quantityInput) {
          quantityInput.min = variant.quantity_min || 1;
          quantityInput.step = variant.quantity_increment || 1;
          quantityInput.value = variant.quantity_min || 1;

          if (variant.quantity_max) {
            quantityInput.max = variant.quantity_max;
          } else {
            quantityInput.removeAttribute('max');
          }
        }

        if (variant.featured_media_id) showMedia(variant.featured_media_id);

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());

        updateOptionAvailability();
      };

      optionButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;

          const optionIndex = Number(button.dataset.optionIndex);
          selectedOptions[optionIndex] = button.dataset.optionValue;

          const variant = findSelectedVariant();
          if (variant) updateVariant(variant);
        });
      });

      root.querySelector('[data-xh-quantity-minus]')?.addEventListener('click', () => {
        if (!quantityInput) return;

        const min = Number(quantityInput.min || 1);
        const step = Number(quantityInput.step || 1);
        const value = Number(quantityInput.value || min);

        quantityInput.value = Math.max(min, value - step);
      });

      root.querySelector('[data-xh-quantity-plus]')?.addEventListener('click', () => {
        if (!quantityInput) return;

        const step = Number(quantityInput.step || 1);
        const max = quantityInput.max ? Number(quantityInput.max) : Number.POSITIVE_INFINITY;
        const value = Number(quantityInput.value || 0);

        quantityInput.value = Math.min(max, value + step);
      });

      buyNowButton?.addEventListener('click', async () => {
        if (!productForm || buyNowButton.disabled) return;

        const previousLabel = buyNowLabel?.textContent || 'Zum Checkout';

        buyNowButton.disabled = true;
        buyNowButton.classList.add('is-loading');
        if (buyNowLabel) buyNowLabel.textContent = 'Wird geöffnet …';

        if (formError) {
          formError.classList.add('hidden');
          formError.textContent = '';
        }

        try {
          const formData = new FormData(productForm);
          const shopRoot = window.Shopify?.routes?.root || '/';

          const response = await fetch(`${shopRoot}cart/add.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
          });

          if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(
              errorData.description ||
              errorData.message ||
              'Der Artikel konnte nicht zur Kasse hinzugefügt werden.'
            );
          }

          window.location.assign(`${shopRoot}checkout`);
        } catch (error) {
          buyNowButton.disabled = false;
          buyNowButton.classList.remove('is-loading');

          if (buyNowLabel) buyNowLabel.textContent = previousLabel;

          if (formError) {
            formError.textContent =
              error instanceof Error
                ? error.message
                : 'Der Direktkauf konnte nicht gestartet werden.';
            formError.classList.remove('hidden');
          }
        }
      });

      const description = root.querySelector('[data-xh-description]');
      const title = root.querySelector('.xh-product-info__title');
      const firstHeading = description?.querySelector(
        ':scope > h1:first-child, :scope > h2:first-child, :scope > h3:first-child'
      );

      if (description) {
        const normalizedTitle = normalize(title?.textContent).replace(/[^\p{L}\p{N}]/gu, '');
        const normalizedSectionTitle = normalize(description.dataset.xhDescriptionTitle).replace(/[^\p{L}\p{N}]/gu, '');

        if (firstHeading) {
          const normalizedHeading = normalize(firstHeading.textContent).replace(/[^\p{L}\p{N}]/gu, '');
          const genericHeadings = [
            'produktinformationen',
            'produktbeschreibung',
            'alleinfosaufeinenblick',
          ];

          if (
            normalizedHeading &&
            (
              normalizedHeading === normalizedTitle ||
              normalizedTitle.includes(normalizedHeading) ||
              normalizedHeading === normalizedSectionTitle ||
              genericHeadings.includes(normalizedHeading)
            )
          ) {
            firstHeading.hidden = true;
          }
        }

        const meaningfulParagraphs = [...description.querySelectorAll(':scope > p')].filter(
          (paragraph) => paragraph.textContent.trim() || paragraph.querySelector('img')
        );
        meaningfulParagraphs[0]?.classList.add('xh-product-story__lead');

        description.querySelectorAll('p').forEach((paragraph) => {
          if (!paragraph.textContent.trim() && !paragraph.querySelector('img, video, iframe')) {
            paragraph.remove();
            return;
          }

          const onlyBoldChild = paragraph.querySelector(':scope > strong:only-child, :scope > b:only-child');
          if (!onlyBoldChild) return;

          const boldText = normalize(onlyBoldChild.textContent);
          const looksLikeHeading =
            boldText.length <= 90 &&
            /^(inhalt|lieferumfang|highlights?|top\s*\d*\s*karten?|details?|hinweis|wichtig|zustand|merkmale)/u.test(boldText);

          if (looksLikeHeading) {
            const replacementHeading = document.createElement('h3');
            replacementHeading.innerHTML = onlyBoldChild.innerHTML;
            paragraph.replaceWith(replacementHeading);
          } else {
            paragraph.classList.add('is-legacy-bold-paragraph');
          }
        });

        description.querySelectorAll('img').forEach((image) => {
          image.loading = 'lazy';
          image.decoding = 'async';

          const rawAlt = String(image.getAttribute('alt') || '').trim();
          const normalizedAlt = normalize(rawAlt);
          const parent = image.closest('p, figure, div');

          let displayAlt = rawAlt;
          if (rawAlt.includes(':')) displayAlt = rawAlt.split(':').slice(1).join(':').trim();
          if (displayAlt) image.setAttribute('alt', displayAlt);

          if (normalizedAlt.startsWith('logo:')) {
            if (parent && parent.querySelectorAll('img').length === 1 && !parent.textContent.trim()) {
              parent.remove();
            } else {
              image.remove();
            }
            return;
          } else if (normalizedAlt.startsWith('klein:') || normalizedAlt.startsWith('small:')) {
            image.classList.add('is-compact');
            parent?.classList.add('xh-product-story__media-row', 'is-compact');
          } else if (normalizedAlt.startsWith('breit:') || normalizedAlt.startsWith('wide:')) {
            image.classList.add('is-wide');
            parent?.classList.add('xh-product-story__media-row', 'is-wide');
          } else if (normalizedAlt.startsWith('karten:') || normalizedAlt.startsWith('cards:')) {
            image.classList.add('is-card-preview');
            parent?.classList.add('xh-product-story__media-row', 'is-card-preview');
          } else {
            image.classList.add('is-content-image');
            parent?.classList.add('xh-product-story__media-row');
          }
        });

        description.querySelectorAll('h2, h3').forEach((heading) => {
          const headingText = normalize(heading.textContent);
          if (headingText.includes('inhalt')) heading.dataset.xhHeadingType = 'content';
          else if (headingText.includes('highlight') || headingText.includes('vorteil')) heading.dataset.xhHeadingType = 'highlight';
          else if (headingText.includes('top') && headingText.includes('karte')) heading.dataset.xhHeadingType = 'cards';
          else if (headingText.includes('hinweis') || headingText.includes('wichtig')) heading.dataset.xhHeadingType = 'notice';
        });
      }

      if (mobileSticky && addButton && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          ([entry]) => {
            const mobile = window.matchMedia('(max-width: 749px)').matches;
            const visible = mobile && !entry.isIntersecting;

            mobileSticky.classList.toggle('is-visible', visible);
            mobileSticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
          },
          { threshold: 0.12 }
        );

        observer.observe(addButton);
      }

      if (initialVariant) updateVariant(initialVariant);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
